export enum MealPlanView {
  Instructions = 'Instructions',
  Summary = 'Summary',
  Details = 'Details',
}

export const MEAL_PLAN_STEP_NUMBER: Record<MealPlanView, number> = {
  [MealPlanView.Instructions]: 1,
  [MealPlanView.Summary]: 2,
  [MealPlanView.Details]: 3,
};

export const MEAL_PLAN_STEP_TITLE: Record<MealPlanView, string> = {
  [MealPlanView.Instructions]: 'Meal plan preferences',
  [MealPlanView.Summary]: 'Review recipe outline',
  [MealPlanView.Details]: 'Review recipes',
};

export const MEAL_PLAN_TOTAL_STEPS = 3;

export type MealType = 'breakfast' | 'lunch' | 'dinner' | 'snack';

export const MEALS: MealType[] = ['breakfast', 'lunch', 'dinner', 'snack'];

export type MacroType = 'calories' | 'carbohydrates' | 'protein' | 'fat';

export const MACROS: MacroType[] = [
  'calories',
  'carbohydrates',
  'protein',
  'fat',
];

export type MealPlanAnalyticsContext = 'in_session' | 'post_session';

export const shouldShowLoadingState = (
  checks: Array<{ isPending: boolean; hasData: boolean }>,
): boolean => {
  return checks.some(({ isPending, hasData }) => isPending && !hasData);
};
